var render = function render(){var _vm=this,_c=_vm._self._c;return _c('interface-modal',{attrs:{"modal-open":_vm.cartVisible,"align":"right"},on:{"close":function($event){return _vm.hideCart()}}},[_c('cart',{on:{"close":function($event){return _vm.hideCart()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }